import { MaterialBlanceState } from '@/services/project/material-balance.service'
import { IMaterialBalanceData, TableRowItem, bigFirstChar } from './excel.service'

interface ProcessTableProps {
  mbData: IMaterialBalanceData
}
const ProcessTable = (props: ProcessTableProps) => {
  const { mbData} = props


  const renderByData = (data: TableRowItem[], phase: string) => {
    return <>
      <tr>
        <td colSpan={2}>{bigFirstChar(phase)} Phase Properties</td>
        <td></td>
        {data[0].streams.map((item, index) => <td key={`${phase}_empty_${index}`}></td>)}
      </tr>
      {data.map((item, index) => {
        return <tr key={`row_${phase}_${index}`}>
          <td colSpan={2}>{item.label}</td>
          <td>{item.unit}</td>
          {item.streams.map((stream) => <td key={`td_${phase}_rho_${stream.id}`}>{stream.value}</td>)}
        </tr>
      })}
    </>
  }

  if (!mbData) return null
  const firstComposition = mbData.composition[0]
  return <div style={{ overflowX: 'auto' }}>
    <table className='bordered-table same-color'>
      <thead>
        <tr>
          <th scope='col' style={{width: 30}}></th>
          <th></th>
          <th></th>
          {firstComposition.streams.map((item) => <th key={`th_${item.id}`}></th>)} 
        </tr>
        
      </thead>
      <tbody>
        <tr>
          <td colSpan={3}>Stream No.</td>
          {firstComposition.streams.map((item, index) => <td key={`streamNo_${item.id}`}>{index + 1}</td>)}
        </tr>
        <tr>
          <td colSpan={3}>Medium / Description</td>
          {firstComposition.streams.map((item) => <td rowSpan={2} key={`Description_${item.id}`}>NG Feed From B.L.</td>)}
        </tr>
        <tr>
          <td></td>
          <td colSpan={2}>Component</td>
        </tr>
        {mbData.composition.map((item, index) => {
          return <tr key={item.label}>
          {index === 0 && <td rowSpan={mbData.composition.length} style={{writingMode: 'sideways-lr'}}>Mole-%</td>}
          <td colSpan={2}>{item.label}</td>
          {item.streams.map((stream) => <td key={`${item.label}_${stream.id}`}>{stream.value}</td>)}  
        </tr>
        })}
       
        {/* attributes */}
        {renderByData(mbData.bulkData, 'bulk')}
        
        {
          mbData.others.map(phaseData => {
            return <>
              {renderByData(phaseData.data, phaseData.name)}
            </>
          })
        }
      </tbody>
    </table>
  </div>
};

export default ProcessTable; 